import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { productFaqs } from './FaqData';
import { FaqItem } from './FaqItem';
import { RiQuestionAnswerLine } from 'react-icons/ri';

const FaqsPreview = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const displayData = productFaqs.slice(0, 5); // ONLY SHOW 5

  return (
    <div className="w-full max-w-7xl mx-auto px-6 py-10">
      <div className="text-center mb-12">
        <div className="inline-flex p-4 bg-rose-50 text-rose-500 rounded-3xl mb-4">
          <RiQuestionAnswerLine size={32} />
        </div>
        <h2 className="text-4xl font-black text-rose-950 uppercase">Common Questions</h2>
      </div>

      <div className="bg-white/40 backdrop-blur-3xl border border-white/60 rounded-[3rem] p-8 shadow-2xl">
        {displayData.map((faq, index) => (
          <FaqItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === index}
            toggle={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
      </div>

      <div className="mt-12 text-center">
        <Link to="/faqs" className="px-10 py-4 bg-rose-600 text-white rounded-full font-bold hover:bg-rose-700 transition-all shadow-lg shadow-rose-200">
          View More Questions
        </Link>
      </div>
    </div>
  );
};

export default FaqsPreview;